import React from 'react';

export default function CardPreview({ imageSrc }) {
  return (
    <div className="p-0 flex items-center justify-center overflow-hidden min-h-[220px] md:min-h-0">
      {imageSrc ? (
        <img
          src={imageSrc}
          alt="Business card"
          className="w-full max-h-[300px] md:max-h-full object-contain rounded-lg shadow"
        />
      ) : (
        <div className="text-gray-400 text-sm">No image</div>
      )}
    </div>
  );
}

